import React, { useEffect, useState } from "react";
const ExamSolution = ({ announcement }) => {
  const [data, setData] = useState([]);
  const showData = () => {
    fetch("https://kvrstarlightmedicalacademy.com/api/examsolution.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  };
  useEffect(() => {
    showData();
  }, []);
  return (
    <>
      <div className="container">
        <div className="row gallery">
          {data.map((img, index) => (
            <div key={index} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <figure>
                <img
                  src={"assets/examsolution/" + img.filename}
                  alt={`Gallery ${index + 1}`}
                  className="full_img"
                />
              </figure>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-light p-3 mt-4 rounded">
        <div className="overflow-hidden whitespace-nowrap">
          <div className="animate-marquee text-primary font-bold">
            {announcement}
          </div>
        </div>
      </div>

      <style>{`
        .animate-marquee {
          display: inline-block;
          padding-left: 50%;
          animation: marquee 15s linear infinite;
        }
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </>
  );
};

export default ExamSolution;
